import { useCallback, useState } from "react"

const useModal = (internalKeys = []) => {
    const isMulti = internalKeys.length > 0
    const [isOpen, setIsOpen] = useState(false)
    const [modals, setModals] = useState(internalKeys.reduce((acc,key)=>{
        acc[key]=false;
        return acc
    },{}));

    if (internalKeys.length === 0) {
        const toggleModal = () => {
            setIsOpen((prev) => !prev)
        }
        return {
            isOpen,
            toggleModal
        }
    }

    // const toggleModal = useCallback((key) => {
    //     if(isMulti){
    //         setModals((prev) => ({ ...prev, [key]: !prev[key] }));
    //     }else {
    //         setSingleModalOpen((prev) => !prev)
    //     }
    // }, [isMulti]);
    //  const isOpen = useCallback((key)=>{
    //     if(isMulti) return modals[key] || false;
    //     return singleModalOpen
    //  },[modals, singleModalOpen, isMulti]);
    // return {
    //     isOpen,
    //     toggleModal
    // }
}
export default useModal